module.exports = __webpack_public_path__ + "img/header.5139fc5f.png";